import * as React from 'react';

import {NavigationStoreModel} from '../../logic';
import {AccountPage} from '../account/AccountPage';
import {HomePage} from '../home/HomePage';
import {HowItWorksPage} from '../how-it-works/HowItWorksPage';
import {LandingPage} from '../landing/LandingPage';
import {LegalPage} from '../legal/LegalPage';
import {LoginPage} from '../login/LoginPage';
import {SignupPage} from '../signup/SignupPage';

export interface ActivePageViewProps {
    model: NavigationStoreModel;
}

export const ActivePageView: React.FunctionComponent<ActivePageViewProps> = ({model}: ActivePageViewProps) => {
    switch (model.currentPage) {
        case 'landing':
            return <LandingPage/>;
        case 'howItWorks':
            return <HowItWorksPage/>;
        case 'login':
            return <LoginPage/>;
        case 'signup':
            return <SignupPage/>;
        case 'home':
            return <HomePage/>;
        case 'account':
            return <AccountPage/>;
        case 'legal':
            return <LegalPage/>;
    }
};
